import "moment-timezone";
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import EditContactForm from './EditContactForm';



class EditModal extends Component {
  render() {
    const { contact, showModal, onConfirmModal, onCloseModal } = this.props
    if (!contact) return <span></span>
    return (
      <Modal show={showModal} onHide={onCloseModal} dialogClassName="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>{contact.id ? 'Edit' : 'New'} Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditContactForm contact={contact} onCancelSubmit={onCloseModal} onSubmit={onConfirmModal} />
        </Modal.Body>
      </Modal>)
  }
}

export default EditModal